// services
import GroupService from 'services/GroupService';

const groupService = GroupService.getInstance();

const configQuery = {
  retry: false,
  enabled: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
};

export const groupsQuery = {
  getGroups: {
    key: 'settings-center-groups',
    resource: groupService.fetchGroupsByCenter,
    config: configQuery,
  },
};
